import { Pipe, PipeTransform } from "@angular/core";
import showdown from "showdown";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({
	standalone: true,
	name: 'markdown'
})
export class MarkdownPipe implements PipeTransform {
	private converter: showdown.Converter;

	constructor(private sanitizer: DomSanitizer) {
		this.converter = new showdown.Converter({
			noHeaderId: true,
			strikethrough: true,
			tables: true,
			tasklists: true
		});
	}

	transform(value: string): string {
		if (!value) {
			return '';
		}
		return this.applyStyling(this.converter.makeHtml(value));
	}

	private applyStyling(value: string): string {
		return value.replace('<pre>', '<pre style="white-space: wrap">');
	}
}
